<template>
  <div class="item-box-430">
    <div v-show="isShowDefaultPage" class="default-page">
      <img :src="emptyIcon">
      <p>
        {{ warningStr }}
      </p>
    </div>
    <section v-show="!isShowDefaultPage" class="main">
      <Tabs v-model="tab" type="card" @on-click="handleTabClick">
        <TabPane label="托管课程分班" name="2"></TabPane>
        <TabPane label="素质课程分班" name="1"></TabPane>
      </Tabs>
      <Button
        type="primary"
        class="batch-btn"
        @click="handleClickBatch"
      >批量设置</Button>
      <div class="table">
        <Table
          :loading="loading"
          border
          :columns="courseColumn"
          :data="courseData"
          :span-method="handleSpan"
          @on-selection-change="onSelectionChange"
          @on-row-click="onRowClick"
        >
          <template slot="classTimeDesc" slot-scope="{ row }">
            <Tag v-for="(item, key) in row.classTimeDesc" :key="key">{{ item }}</Tag>
          </template>
          <template slot="maxNum" slot-scope="{ row, index }">
            <div v-show="row['isOpen']">
              <InputNumber
                v-model="courseData[index]['maxNum']"
                :min="1"
                placeholder="请输入"
                :disabled="smartPartitionType == 2"
              ></InputNumber>
            </div>
            <p v-show="!row.isOpen">--</p>
          </template>
          <template slot="weekCycleNum" slot-scope="{ row, index }">
            <div v-show="row['isOpen']">
              <InputNumber
                v-model="courseData[index]['weekCycleNum']"
                :min="1"
                disabled
                placeholder="请输入"
              ></InputNumber>
            </div>
            <p v-show="!row.isOpen">--</p>
          </template>
          <template slot="isOpen" slot-scope="{ row, index }">
            <div
              v-if="!courseData[index]['disabled']"
              class="switch-mask"
              @click="handleSwitch(index)"
            ></div>
            <i-switch
              v-if="!courseData[index]['disabled']"
              v-model="courseData[index]['isOpen']"
            ></i-switch>
            <i-switch v-else disabled=""></i-switch>
          </template>
          <template slot="classroomTotal" slot-scope="{ row, index }">
            {{ row['isOpen'] ? row.classroomTotal : '--' }}
          </template>
          <template slot="startTime" slot-scope="{ row, index }">
            <div v-show="row['isOpen']" class="classroom-day">
              <span>{{ row.startTime }}</span><span
                v-if="!row.startTime"
                class="placeholder"
              >请选择开课日期</span><Icon type="md-arrow-dropdown"></Icon>
              <DatePicker
                :ref="`datePicker` + index"
                type="date"
                placeholder="Select date"
                style="width: 200px"
                class="date-pick"
                :value="dateValue"
                :transfer="true"
                :options="datePickeroptions(index)"
                @on-change="handleDatePickChange"
                @on-open-change="onDatePickOpenChange"
              ></DatePicker>
            </div>
            <p v-show="!row['isOpen']"></p>
          </template>
          <template slot="action" slot-scope="{ row, index }">
            <div class="action-main">
              <RadioGroup v-model="smartPartitionType" vertical>
                <Radio :label="2">
                  <span class="">按学生所在班级分班</span>
                </Radio>
                <Radio :label="1">
                  <span class="">按最低开班数智能分班</span>
                </Radio>
              </RadioGroup>
            </div>
          </template>
        </Table>
        <div class="page-box">
          <Page
            :total="pageInfo.total"
            show-total
            show-sizer
            show-elevator
            :current="pageInfo.pageNum"
            class="page-right"
            :page-size-opts="pageSizeOpts"
            :transfer="true"
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
          ></Page>
        </div>
      </div>
      <div class="footer">
        <p class="remark remark-title">说明：</p>
        <p class="remark">
          （1）批量智能分班，只适合周期循环的课程商品，操作前请务必准确核对，不是该类型的课程请手动分班。
        </p>
        <div class="btn-main">
          <Button class="cancel" @click="handleCancel">上一步</Button>
          <Button
            type="primary"
            :loading="sureBtnLoading"
            @click="handleConfirm"
          >分班确认</Button>
        </div>
      </div>
    </section>
    <BeforeDivideClassModal
      :show="batchShow"
      :smart-partition-type="smartPartitionType"
      :select-rows="selectRows"
      @on-Finish="onBDFinish"
    ></BeforeDivideClassModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { courseColumn } from '../data/BeforeDivideClassTable.js';
import BeforeDivideClassModal from './BeforeDivideClassModal.vue';
export default {
  components: {
    BeforeDivideClassModal
  },
  props: {
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    branchId: {
      type: String,
      default: ''
    },
    termCode: {
      type: String,
      default: ''
    },
    yearCode: {
      type: Number,
      default: 0
    },
    // 学期id
    random: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      emptyIcon: require('@assets/img/empty2@2x.png'),
      smartPartitionType: 2, // 1: 按学生所在班级分班  2:按最低开班数智能分班
      tab: '2', // 2: 托管课程分班 1:素质课程分班
      loading: false,
      courseColumn: courseColumn,
      courseData: [],
      dateValue: '',
      map: {

      }, // 勾选记录
      selectIndex: 0,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 课班列表分页信息
      batchShow: false,
      selectRows: [],
      sureBtnLoading: false
    };
  },
  computed: {
    ...mapGetters([
      'theUserIdentity'
    ]),
    // 是否显示缺省页
    isShowDefaultPage() {
      return !this.termCode || !this.yearCode || !this.branchId || !this.schoolId;
    },
    warningStr() {
      return `请先选中${this.theUserIdentity != 'school' ? '学校、' : ''
      }学期后，再进行分班`;
    }

  },

  watch: {

    random() {
      console.log('yearCode', this.termCode, this.yearCode, this.branchId, this.schoolId);
      if (this.isShowDefaultPage) {
        this.$Message['warning']({
          background: true,
          content: this.warningStr
        });
      } else {
        this.init();
      }
    },
    tab(newVal) {
      if (newVal === '2') {
        this.smartPartitionType = 2;
      } else if (newVal === '1') {
        this.smartPartitionType = 1;
      }
    }
  },
  mounted() {
    console.log(11111);
    !this.isShowDefaultPage && this.init();
    this.$eventHub.$on('refreshWaitPartition', data => {
      this.getListOfWaitPartition();
    });
  },
  destroyed() {
    this.$eventHub.$off('refreshWaitPartition');
  },
  methods: {
    // 设置 日期选中器 禁止选项
    datePickeroptions(index) {
      const _this = this;
      return {
        disabledDate(date) {
          const weekDate = _this.getDateWeekDate(date);
          const weekDates = _this.courseData[index]['classTimeList'] ? _this.courseData[index]['classTimeList'].map(item => {
            return item.weekDate;
          }) : [];

          return !weekDates.includes(weekDate);
        }
      };
    },
    // 获取某个日期是周几（其中周日在这边是7） date是newdate格式化之后的
    getDateWeekDate(date) {
      let weekDate = date.getDay();
      weekDate === 0 ? weekDate = 7 : '';
      return weekDate;
    },
    // init
    init() {
      this.pageInfo = {
        total: 0,
        pageNum: 1,
        pageSize: this.pageInfo.pageSize
      };
      this.getListOfWaitPartition();
    },
    // 批量设置完成
    onBDFinish(val) {
      this.batchShow = false;
      if (val.type === 'cancel') {
        return null;
      }
      const ids = this.selectRows.map(item => { return item.productId; });
      this.courseData.forEach(item => {
        if (ids.includes(item.productId)) {
          switch (Number(val.index)) {
            case 0:
              item.maxNum = val.form.maxNum;
              break;
            case 1:
              item.weekCycleNum = val.form.weekCycleNum;
              break;

            case 2:
              item.startTime = val.form.startTime;
              break;
          }
          item.isOpen = true;
          item._checked = true;
        }
      });
      console.log('ids', ids);
    },
    // 点击批量设置
    handleClickBatch() {
      if (!this.selectRows.length) {
        return this.$Message.warning('请先勾选记录');
      }
      this.batchShow = true;
    },
    // 表格选中
    onSelectionChange(rows) {
      this.selectRows = rows;
      // console.log(rows)
    },
    // 表格点击某一行
    onRowClick(row, index) {
      this.selectIndex = index;
      console.log(row, index);
    },
    // 获取列表参数
    getParameter() {
      return {
        schoolId: this.schoolId,
        // termId: this.termId,
        termCode: this.termCode,
        yearCode: this.yearCode,
        branchId: this.branchId,
        classType: this.tab,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
    },
    // 获取待分班列表数据
    async getListOfWaitPartition() {
      try {
        this.loading = true;
        const parameter = this.getParameter();
        const res = await courseSchedulCenter.getListOfWaitPartition(parameter);
        if (res.status === 200) {
          this.pageInfo.total = Number(res.message.total);
          const { list } = res.message;
          const productIds = list.map(item => {
            return item.productId;
          });
          const busiObjIds = productIds.length > 0 ? await this.getProgressData(productIds, false) : [];
          this.courseData = list.map((item, index) => {
            try {
              item.classTimeDesc = item.classTimeDesc ? item.classTimeDesc.split(';').filter(item => { return item != ''; }) : [];
              // item.startTime = item.startTime ? formatTimestamp(item.startTime, 'YYYY-MM-DD') : '';
              item.startTime = '';
            } catch (err) {
              console.log(err);
            }
            const tag = busiObjIds.includes(item.productId);
            return {
              ...item,
              isOpen: !tag && index === 0,
              disabled: tag,
              _disabled: tag,
              maxNum: 20,
              weekCycleNum: 1
            };
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async getProgressData(productIds, showModal = true) {
      return new Promise(async(resolve, reject) => {
        try {
          const params = {
            busiCode: 1, //  业务编码 1-智能分班
            schoolIdList: [this.schoolId], // 学校id
            yearCode: this.yearCode,
            termCode: this.termCode,
            pageSize: productIds.length,
            pageNo: 1,
            busiObjIds: productIds,
            procStsList: [0, 2],
            exeFlag: 1
          };
          const res = await courseSchedulCenter.getTaskIngListApi(params);
          if (res.status === 200 && showModal) {
            const productNameList = res.message.map(item => {
              return item.properties.productName;
            });
            const productNameStr = productNameList.join('、');
            if (productNameStr) {
              this.$Modal.info({
                title: '提示',
                content: `${productNameStr}，存在分班中的任务，请重新检索后再次尝试分班操作！`
              });
              resolve(true);
            } else {
              resolve(false);
            }
          } else if (res.status === 200 && !showModal) {
            const busiObjIds = res.message.map(item => {
              return item.batchProcData.busiObjId;
            });
            resolve(busiObjIds);
          } else {
            showModal ? reject(false) : resolve([]);
          }
        } catch (err) {
          console.log(err);
          showModal ? reject(false) : resolve([]);
        }
      });
    },
    // 托管课程分班 & 素质课程分班 tab点击
    handleTabClick() {
      this.init();
    },
    // 分页
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getListOfWaitPartition();
    },
    handlePageSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getListOfWaitPartition();
    },
    // 合并单元格
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 9) {
        // 计算合并的行数列数
        const x = this.courseData.length;
        const y = 1;
        return [x, y];
      }
    },
    // 日期选择改变
    handleDatePickChange(date, v) {
      this.courseData[this.selectIndex]['startTime'] = date;
    },
    // 日期组件打开时
    onDatePickOpenChange(status) {
      if (status) {
        this.dateValue = this.courseData[this.selectIndex]['startTime'];
      }
    },
    // 是否开班切换
    handleSwitch(index) {
      this.courseData[index]['isOpen'] = !this.courseData[index]['isOpen'];

      return null;
      if (!this.courseData[index]['isOpen']) {
        this.$Modal.confirm({
          title: '提示',
          content: `是否切换至 ${this.courseData[index]['productName']} 进行分班操作？`,
          onOk: () => {
            this.courseData.forEach((item, key) => {
              if (index != key) {
                item.isOpen = false;
              } else {
                item.isOpen = true;
                this.selectIndex = index;
              }
            });
          },
          onCancel: () => {

          }
        });
      }
    },
    checkConfirmParameter(data) {
      const res = {
        code: 200,
        str: ''
      };
      for (const item of data) {
        if (!item.maxNum || item.maxNum < 1) {
          res.code = 501;
          res.str = '每班人数上限不能为空，且需要>=1';
          return res;
        }
        if (!item.startTime) {
          res.code = 501;
          res.str = '请选择开课日期';
          return res;
        }
        if (!item.weekCycleNum || item.maxNum < 1) {
          res.code = 501;
          res.str = '周期循环不可为空，且需要>=1';
          return res;
        }
      }

      return res;
    },
    // 确认
    async handleConfirm() {
      const results = this.courseData.filter(item => { return item.isOpen === true; });
      if (results.length == 0) {
        this.$Message.warning('请选择要开班的课程');
        return null;
      }
      const numTotal = results.reduce((pre, cur) => {
        console.log(pre, cur);
        return pre + cur.enrollNum;
      }, 0);
      // if (numTotal > 200) {
      //   this.$Message.warning('分班人数不能超过200人');
      //   return null;
      // }
      // const { productId, maxNum, startTime, weekCycleNum } = this.courseData[this.selectIndex];
      const productIds = results.map(item => {
        return item.productId;
      });
      this.sureBtnLoading = true;
      try {
        const tag = await this.getProgressData(productIds);
        if (tag) {
          return false;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.sureBtnLoading = false;
      }

      const res = this.checkConfirmParameter(results);
      if (res.code != 200) {
        this.$Message['warning']({
          background: true,
          content: res.str
        });
        return null;
      }
      const map = {};
      for (const item of results) {
        map[item.productId] = {
          startTime: item.startTime,
          weekCycleNum: item.weekCycleNum,
          limitOfStuNum: item.maxNum
        };
      }

      this.$emit('on-finish', {
        step: 1,
        data: {
          productIds: map,
          smartPartitionType: this.smartPartitionType
        }
      });
    },
    // 取消
    handleCancel() {
      this.$Modal.confirm({
        title: '提示',
        content: `是否回到上一步？回到上一步后当前数据将不会保存`,
        cancelText: '我再想想',
        onOk: () => {
          this.$router.push({ name: 'courseSchedulCenter_divideClassManage_list_smartDivideClassEmpty' });
          // this.selectIndex = 0;
          // this.tab = '1'
          // this.smartPartitionType = 1
          // this.init()
        },
        onCancel: () => {

        }
      });
    }
  }
};
</script>
<style lang="scss" >
.before-divide-class-top-header {
  background: rgba(97, 73, 241, 0.08) !important;
}
</style>
<style lang="scss" scoped>
.default-page {
  text-align: center;
  padding: 16px 0;
  img {
    margin-bottom: 32px;
  }
  p {
    font-weight: bold;
    font-size: 20px;
  }
}
.main {
  padding-bottom: 200px;
  position: relative;
  .batch-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
  .table {
    .switch-mask {
      position: absolute;
      width: 60px;
      height: 30px;
      z-index: 1;
    }
    .classroom-day {
      position: relative;
      line-height: 28px;
      .placeholder {
        color: #999;
        opacity: 0.8;
      }
      .date-pick {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
    .action-main {
      span {
        display: inline-block;
        width: 140px;
        text-align: left;
      }
    }
  }
  .page-box {
    padding: 16px;
    text-align: right;
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 180px;
    padding: 8px 32px;
    background-color: #fff;
    border-top: 1px solid #ececee;
    z-index: 1000;
    .remark {
      color: #ff3f3f;
      font-size: 16px;
      margin-bottom: 8px;
    }
    .remark-title {
      font-size: 20px;
    }
    .btn-main {
      display: flex;
      justify-content: center;
      padding-top: 16px;
      .cancel {
        margin-right: 16px;
      }
    }
  }
}
</style>

